var _AggregateEnumerator_enumerator, _AggregateEnumerator_aggregateFunction, _AggregateEnumerator_initialValue, _AggregateEnumerator_accumulate;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
import NullReferenceException from '../Exceptions/NullReferenceException';
/**
 *
 */
export default class AggregateEnumerator extends EnumeratorBase {
    constructor(enumerator, aggregateFunction, initialValue) {
        super();
        _AggregateEnumerator_enumerator.set(this, void 0);
        _AggregateEnumerator_aggregateFunction.set(this, void 0);
        _AggregateEnumerator_initialValue.set(this, void 0);
        _AggregateEnumerator_accumulate.set(this, void 0);
        __classPrivateFieldSet(this, _AggregateEnumerator_enumerator, enumerator, "f");
        __classPrivateFieldSet(this, _AggregateEnumerator_aggregateFunction, aggregateFunction, "f");
        __classPrivateFieldSet(this, _AggregateEnumerator_accumulate, initialValue, "f");
        __classPrivateFieldSet(this, _AggregateEnumerator_initialValue, initialValue, "f");
    }
    get current() {
        if (isUndefinedOrNull(__classPrivateFieldGet(this, _AggregateEnumerator_accumulate, "f"))) {
            throw new NullReferenceException();
        }
        return __classPrivateFieldGet(this, _AggregateEnumerator_accumulate, "f");
    }
    moveNext() {
        const currentValue = __classPrivateFieldSet(this, _AggregateEnumerator_accumulate, this.peek(), "f");
        if (currentValue === undefined) {
            return false;
        }
        return __classPrivateFieldGet(this, _AggregateEnumerator_enumerator, "f").moveNext();
    }
    peek() {
        const item = __classPrivateFieldGet(this, _AggregateEnumerator_enumerator, "f").peek();
        if (item === undefined) {
            return;
        }
        return __classPrivateFieldGet(this, _AggregateEnumerator_aggregateFunction, "f").call(this, __classPrivateFieldGet(this, _AggregateEnumerator_accumulate, "f"), item);
    }
    reset() {
        __classPrivateFieldGet(this, _AggregateEnumerator_enumerator, "f").reset();
        __classPrivateFieldSet(this, _AggregateEnumerator_accumulate, __classPrivateFieldGet(this, _AggregateEnumerator_initialValue, "f"), "f");
    }
}
_AggregateEnumerator_enumerator = new WeakMap(), _AggregateEnumerator_aggregateFunction = new WeakMap(), _AggregateEnumerator_initialValue = new WeakMap(), _AggregateEnumerator_accumulate = new WeakMap();
